import React, { useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { FaWandMagicSparkles } from 'react-icons/fa6'
import { MdAdd, MdDelete } from 'react-icons/md'
import ReactPaginate from 'react-paginate'
import { Button, Modal, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addAllDiagnosis, deleteAllDiagnosis, getAllDiagnosis, searchAllDiagnosis, showAllDiagnosis, updateAllDiagnosis } from '../../../redux/actions/Feedback.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';

const DiagnosisCard = ({ patientIds }) => {

    const dispatch = useDispatch()
    const diagnosisDatas = useSelector((state) => state.feedback)

    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [ids, setIds] = useState()

    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const updateToggle = () => { setUpdateModal(!updateModal) }
    const type = localStorage.getItem('type')
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }
    const initialValues = {
        diagnosisName: ''
    }

    const [formData, setFormData] = useState({ diagnosisName: '' })

    const validationSchema = Yup.object().shape({
        diagnosisName: Yup.string().required('Diagnosis Name is required')
    });

    const [diagnosisData, setDiagnosisData] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });

    const searchData = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || ''
        };
        setSearchDefault(newSearchParams);
        dispatch(searchAllDiagnosis(newSearchParams))
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        diagnosisDatas?.showAllDiagnosis?.data?.totalCount / postPerPage,
    );

    const handleAdd = (values, { resetForm }) => {
        const payload = {
            patientId: patientIds,
            diagnosisName: values.diagnosisName
        }
        dispatch(addAllDiagnosis(payload, patientIds, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpdate = (values) => {
        const payload = {
            patientId: patientIds,
            diagnosisName: values.diagnosisName
        }
        dispatch(updateAllDiagnosis(payload, ids, patientIds, limits)).then(() => {
            updateToggle()
        })
    }

    const handleDelete = () => {
        dispatch(deleteAllDiagnosis(ids, patientIds, limits)).then(() => {
            deleteToggle()
            setMainPage(1)
        })
    }

    useEffect(() => {
        dispatch(getAllDiagnosis())
        if (patientIds) {
            dispatch(showAllDiagnosis(patientIds, limits))
        }
    }, [mainPage, rowsPerPage, patientIds])

    return (
        <>
            <div className='col-lg-6'>
                <div className="!bg-[#fff] shadow p-4 rounded-4 h-full">
                    <div className="d-flex justify-between">
                        <div className="flex gap-3 items-center">
                            <FaWandMagicSparkles className="fs-6" />
                            <h6 className="mb-0">Diagnosis</h6>
                        </div>

                        <div onClick={toggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdAdd className="fs-4 text-danger fw-bold" /></button>
                        </div>
                    </div>
                    <div className="mt-3">
                        <TableContainer>
                            <Table variant="simple" className="table-bordered">
                                <Thead className="!bg-theme-dark">
                                    <Tr>
                                        <Th className="!text-white">Date</Th>
                                        <Th className="!text-white">Diagnosis</Th>
                                        <Th className="!text-white">User</Th>
                                        <Th className="!text-white">Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        diagnosisDatas?.showAllDiagnosis?.data?.diagnosesData?.length > 0 ? (
                                            diagnosisDatas?.showAllDiagnosis?.data?.diagnosesData?.map((res) => {
                                                return (
                                                    <Tr key={res._id}>
                                                        <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                        <Td>{res.diagnosisName}</Td>
                                                        <Td>{res?.addedByUser?.name}</Td>
                                                        <Td>
                                                            <div className='flex items-center gap-3'>
                                                                <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FaEdit className='text-success' onClick={() => { updateToggle(); setIds(res._id); setFormData(res) }} title='update' /></button>
                                                                <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdDelete className="text-danger" title="delete" onClick={() => { deleteToggle(); setIds(res._id) }} /></button>
                                                            </div>
                                                        </Td>
                                                    </Tr>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={4} textAlign={'center'}>No any diagnosis</Td>
                                            </Tr>
                                        )
                                    }

                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="flex justify-between items-center mt-2 text-sm">
                        <div>
                            Rows per page:
                            <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="ms-2 border rounded-md focus:outline-none"
                            >
                                <option value="">Select</option>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                            </select>
                        </div>

                        <ReactPaginate
                            breakLabel="..."
                            nextLabel=" >"
                            onPageChange={ChangeMainPage}
                            pageRangeDisplayed={5}
                            pageCount={PageCount}
                            previousLabel="< "
                            renderOnZeroPageCount={null}
                            className="pagination"
                        />
                    </div>
                </div>
            </div>

            {/* Add Toggle */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Diagnosis</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAdd}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Diagnosis Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="diagnosisName"
                                                    placeholder={values.diagnosisName || 'Select Diagnosis'}
                                                    value={values.diagnosisName}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setDiagnosisData(!diagnosisData);
                                                    }}
                                                />

                                                <div
                                                    className={`${diagnosisData
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Diagnosis`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {diagnosisDatas?.getAllDiagnosis?.data?.Diagnosis?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('diagnosisName', res.diagnosis);
                                                                setDiagnosisData(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.diagnosis}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="diagnosisName" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* Update Toggle */}
            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Diagnosis</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Diagnosis Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="diagnosisName"
                                                    placeholder={values.diagnosisName || 'Select Diagnosis'}
                                                    value={values.diagnosisName}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setDiagnosisData(!diagnosisData);
                                                    }}
                                                />

                                                <div
                                                    className={`${diagnosisData
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Diagnosis`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {diagnosisDatas?.getAllDiagnosis?.data?.Diagnosis?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('diagnosisName', res.diagnosis);
                                                                setDiagnosisData(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.diagnosis}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="diagnosisName" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DiagnosisCard
